import { USER_CREATED_RECIPE } from "../../../app/constants/constants";

export enum SubStepTypeEnum {
  INGREDIENTS = 'ingredients',
  OUTSIDE_INSTRUCTION = 'outsideInstruction',
  INSTRUCTION = 'instruction',
  CUSTOM_INGREDIENT = 'customIngredients',
}
export enum HeatingModeEnum {
  TAT = 'TAT',
  CLASSIC = 'CLASSIC',
  RICECOOKER = 'RICECOOKER'
}

export enum LocationEnum {
  JAR = 'jar',
  BOWL = 'bowl',
  NONE = 'none',
}

export enum SubStepEditEnum {
  EDIT_SUBSTEP = "edit",
  ADD_SUBSTEP = "add",
  REMOVE_SUBSTEP = "remove"
}

export enum CreationModeEnum {
  CREATED_FROM_SCRATCH = 'createdFromScratch',
  AI_GENERATED = 'aiGenerated',
  DUPLICATE_RECIPE = 'duplicateRecipe'
}

export const CREATED_SOURCE = {
  RECIPE_ADMIN: "recipeAdmin",
  USER_CREATED: "userCreated",
  MOBILE_APP: 'mobileApp'
}

export const SINGULAR_PHRASE = "a ";
export const MULTIPLE_PHRASE = "the ";
export const COLEN = ":";
export const temperatureASCII = "\u02DA";
export const COOKING_NOTES = "notes";
export const INSTRUCTIONS = "instruction";
export const TIME = 'time';
export const SPEED = 'speed';
export const TEMPERATURE = 'temperature';
export const COOKING_NOTES_PLACEHOLDER = 'For Eg: Besan Flour 250g,Keep the marinated paneer aside for 30 mins...';
export const SUB_STEP_TITLE_PLACEHOLDER = 'Title: Tempering Spices...';
export const TOOLBAR_OPTIONS = [
  ['bold', 'italic', 'underline'],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }]
];

export const DEFAULT_IMG = 'https://images.pexels.com/photos/6448483/pexels-photo-6448483.jpeg?auto=compress&cs=tinysrgb&w=1440&h=80&dpr=1';

export const RECIPE_CREATION_OPTIONS = {
  TEMPLATE: 'template',
  DUPLICATE: 'duplicate',
}
